import React from "react"
import { MdOutlineAddCircleOutline } from "react-icons/md"
import MI_Ext from "./_ext"

class MI_create extends MI_Ext {
  renderIcon = () => {
    return <MdOutlineAddCircleOutline />
  }
}
export default MI_create
